module.exports = __webpack_public_path__ + "img/idphoto_null@3x.9d3f5af9.png";